import React,{useEffect, useState} from 'react'
import './style.css'
import data from '../../../constant/data.json';
import TestMonialCard from '../../../components/main/TestmonialCard';
import { getInterPolateValue } from '../../../utils/helper';

  
export default function TestmonialSection(props) {
      const [positionY,setPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
   
    setPosition(position - 7351);
};
useEffect(() => { 
    window.addEventListener('scroll', handleScroll);
    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
}, []);
    return (
        <div className='test-sec-main'>
         <p className='test-head1-text'>TESTIMONIALS</p>
         <p className='test-head2-text'>what they said</p>
           <img className='test-fromheart-img' src={require("../../../assets/images/fromheart.png")} />
           {data.testimonial.map(item =>{
            return (
                <TestMonialCard
                left={item.left}
                top={item.top}
                image={item.image}
                x={getInterPolateValue((positionY),0,1000,0,item.x)}
                y={getInterPolateValue((positionY),0,1000,0,item.y)}
                r={getInterPolateValue((positionY),0,1000,item.r1,item.r2)}
                key={item.id} name={item.name} name2={item.name2} designation={item.designation}  company={item.company} content={item.content} />
            )
           })}
        </div>
    )
}
